import { Folder } from '@/api/generatedApi';

export const getDescendantIds = (folderId: string, folders: Folder[]): Set<string> => {
  const descendants = new Set<string>();
  const addDescendants = (parentId: string) => {
    for (const folder of folders) {
      if (folder.parentFolderId === parentId && !descendants.has(folder.id)) {
        descendants.add(folder.id);
        addDescendants(folder.id);
      }
    }
  };
  addDescendants(folderId);
  return descendants;
};

export const getAncestorIds = (folderId: string | undefined, folders: Folder[]): string[] => {
  if (!folderId || folders.length === 0) return [];
  const ancestors: string[] = [];
  const folder = folders.find(f => f.id === folderId);
  let currentParentId = folder?.parentFolderId;
  while (currentParentId) {
    const parent = folders.find(f => f.id === currentParentId);
    if (!parent) break;
    ancestors.push(parent.id);
    currentParentId = parent.parentFolderId;
  }
  return ancestors;
};
